<template>
  <div class="footer-container">
    <div class="footer-wrapper">
      <!-- 左侧：Logo -->
      <div class="footer-col">
        <div class="logo">
          <img :src="require('@/assets/footer-logo.png')" alt="点酷网络" />
        </div>
      </div>

      <!-- 中间：二维码 -->
      <div class="footer-col text-center">
        <div class="qrcode">
          <img :src="require('@/assets/image/qrcode.png')" alt="微信二维码" />
        </div>
        <p class="qrcode-text">扫微信<br />获更多信息</p>
      </div>

      <!-- 右侧：联系信息 -->
      <div class="footer-col">
        <h3 class="company-name">点酷网络信息技术有限公司</h3>
        <p class="contact-info">地址:南京市麒麟科技创新园智汇路300号B单元二楼</p>
        <p class="contact-info">客服热线:4008161208</p>
        <p class="contact-info">邮箱:service@njdiancool.com</p>
      </div>
    </div>

    <div class="footer-bottom">
      <a-icon type="trademark" /> Copyright ©2017 - 2026 南京点酷网络信息技术有限公司
      <a href="https://beian.miit.gov.cn" target="_blank">苏ICP备18020708号-1</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss">
.footer-container {
  width: 100%;
  min-height: 557px;
  background: #111f3c; // 先设为深蓝，避免灰色
  background-image: url('~@/assets/image/foot.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 90px 180px 30px;
  color: #ffffff;
  box-sizing: border-box;
  position: relative;

  .footer-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 40px;
    min-height: 360px;

    .footer-col {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      &.text-center {
        align-items: center;
      }

      .logo {
        margin-bottom: 20px;

        img {
          height: 120px;
          width: auto;
        }
      }

      .qrcode {
        margin-bottom: 16px;

        img {
          height: 120px;
          width: 120px;
          border-radius: 8px;
        }
      }

      .qrcode-text {
        font-size: 16px;
        line-height: 1.4;
        text-align: center;
        margin: 0;
      }

      h3 {
        font-size: 18px;
        margin: 0 0 16px 0;
        font-weight: 500;
      }

      .contact-info {
        font-size: 14px;
        line-height: 1.6;
        margin: 8px 0;
        white-space: normal;
      }
    }
  }

  .footer-bottom {
    text-align: center;
    color: #e2dfd5;
    font-size: 14px;
    line-height: 1.6;
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);

    a {
      color: #e2dfd5;
      text-decoration: none;
      margin-left: 8px;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  // 平板适配
  @media (max-width: 1024px) {
    padding: 72px 60px 24px;

    .footer-wrapper {
      flex-direction: column;
      align-items: center;
      gap: 32px;
    }

    .footer-col {
      width: 100%;
      max-width: 560px;
      align-items: center !important;

      .logo img {
        height: 100px;
      }

      .qrcode img {
        height: 100px;
        width: 100px;
      }

      h3 {
        font-size: 16px;
      }

      .contact-info {
        font-size: 13px;
      }
    }
  }

  // 手机适配
  @media (max-width: 768px) {
    padding: 40px 16px 20px;
    background: #111f3c !important;

    .footer-wrapper {
      gap: 28px;
    }

    .footer-col {
      .logo img {
        height: 80px;
      }

      .qrcode img {
        height: 80px;
        width: 80px;
      }

      .qrcode-text {
        font-size: 14px;
      }

      h3 {
        font-size: 15px;
      }

      .contact-info {
        font-size: 12px;
        margin: 6px 0;
      }
    }

    .footer-bottom {
      font-size: 12px;
      padding-top: 16px;
    }
  }
}
</style>